import React, { Component } from 'react';
import AuthService from '../../AuthService';
import constants from '../../../config';

var Auth = new AuthService();

export default class UserSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      results: [],
      loading: false,
      open: false,
    };
    this._searchTimer = null;
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    var self = this;
    this._closeSearch = function(e) {
      if (self._searchRef && !self._searchRef.contains(e.target)) {
        self.setState({ open: false });
      }
    };
    document.addEventListener('mousedown', this._closeSearch);
  }

  componentWillUnmount() {
    if (this._closeSearch) document.removeEventListener('mousedown', this._closeSearch);
    if (this._searchTimer) clearTimeout(this._searchTimer);
  }

  handleSearch(e) {
    var self = this;
    var query = e.target.value;
    this.setState({ query: query });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    if (!query || query.trim().length < 2) {
      this.setState({ results: [], open: false, loading: false });
      return;
    }
    this.setState({ loading: true });
    this._searchTimer = setTimeout(function() {
      Auth.fetch(constants.DOMAIN + '/api/v1/admin/users/search?q=' + encodeURIComponent(query.trim()))
        .then(function(data) {
          self.setState({ results: data.users || [], open: true, loading: false });
        })
        .catch(function() {
          self.setState({ results: [], open: false, loading: false });
        });
    }, 300);
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    return (
      <div className="tw-relative tw-flex-1 tw-max-w-xs" ref={function(el) { self._searchRef = el; }}>
        <div className="tw-relative">
          <i className="fa fa-search tw-absolute tw-text-[#999] tw-text-xs tw-pointer-events-none" style={{ left: 12, top: '50%', transform: 'translateY(-50%)' }} />
          <input
            type="text"
            value={this.state.query}
            onChange={this.handleSearch}
            onFocus={function() { if (self.state.results.length > 0) self.setState({ open: true }); }}
            onKeyDown={function(e) { if (e.key === 'Escape') self.setState({ open: false }); }}
            placeholder="Search users..."
            className="tw-w-full tw-pl-8 tw-pr-3 tw-py-2 tw-text-sm tw-rounded-lg tw-text-[#1a1a1a] dark:tw-text-white tw-outline-none tw-transition-colors"
            style={{ backgroundColor: isDark ? '#111' : '#fff', border: '1px solid ' + (this.state.open ? '#D4A843' : (isDark ? '#444' : '#ddd')) }}
          />
          {this.state.loading && (
            <i className="fa fa-circle-o-notch fa-spin tw-absolute tw-right-3 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-xs" style={{ color: '#D4A843' }} />
          )}
        </div>
        {this.state.open && this.state.results.length > 0 && (
          <div className="tw-absolute tw-top-full tw-left-0 tw-right-0 tw-mt-1 tw-rounded-lg tw-shadow-lg tw-overflow-hidden tw-z-50" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#ddd') }}>
            {this.state.results.map(function(u) {
              var statusColor = u.status === 'suspended' ? '#f59e0b' : u.status === 'banned' ? '#ef4444' : '#10B981';
              return (
                <button
                  key={u._id}
                  className="tw-w-full tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-left hover:tw-bg-[#f5f5f5] dark:hover:tw-bg-[#222] tw-transition-colors"
                  onClick={function() {
                    self.setState({ open: false, query: '', results: [] });
                    if (self.props.onSelectUser) self.props.onSelectUser(u._id);
                  }}
                >
                  <img
                    src={u.image ? (u.image.startsWith('http') ? u.image : constants.DOMAIN + '/' + u.image) : '/images/default-avatar.png'}
                    alt=""
                    className="tw-w-8 tw-h-8 tw-rounded-full tw-object-cover tw-flex-shrink-0"
                    style={{ border: '2px solid ' + statusColor }}
                  />
                  <div className="tw-flex-1 tw-min-w-0">
                    <div className="tw-flex tw-items-center tw-gap-1.5">
                      <span className="tw-text-sm tw-font-medium tw-text-[#1a1a1a] dark:tw-text-white tw-truncate">{u.userName}</span>
                      {u.role === 'admin' && (
                        <span className="tw-text-[10px] tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium" style={{ backgroundColor: '#D4A84320', color: '#D4A843' }}>admin</span>
                      )}
                      {u.status !== 'active' && (
                        <span className="tw-text-[10px] tw-px-1.5 tw-py-0.5 tw-rounded tw-font-medium" style={{ backgroundColor: statusColor + '20', color: statusColor }}>{u.status}</span>
                      )}
                    </div>
                    <div className="tw-text-xs tw-text-[#999] tw-truncate">{u.email}</div>
                  </div>
                  {u.strikeCount > 0 && (
                    <span className="tw-text-xs tw-font-medium tw-flex-shrink-0" style={{ color: '#ef4444' }}>
                      <i className="fa fa-exclamation-triangle tw-mr-0.5" />{u.strikeCount}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        )}
        {this.state.open && this.state.results.length === 0 && !this.state.loading && this.state.query.trim().length >= 2 && (
          <div className="tw-absolute tw-top-full tw-left-0 tw-right-0 tw-mt-1 tw-rounded-lg tw-shadow-lg tw-p-4 tw-text-center tw-z-50" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#333' : '#ddd') }}>
            <span className="tw-text-sm tw-text-[#999]">No users found</span>
          </div>
        )}
      </div>
    );
  }
}
